import { gql } from "@apollo/client";

export const updateUserPointsMutation = gql`mutation UpdateUserPoints($input: UpdateUserPointsInput!){
  updateUserPoints(input: $input){
  id
  userPoints
  }
 }`;